import { render, staticRenderFns } from "./UserFelicaSettings.vue?vue&type=template&id=68a821d8&scoped=true&"
import script from "./UserFelicaSettings.vue?vue&type=script&lang=js&"
export * from "./UserFelicaSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a821d8",
  null
  
)

export default component.exports